import { Button, Dialog, DialogActions, DialogContent, Divider, Stack, Typography } from '@mui/material'
import DraggableDialogTitle from '../../../common/DraggableDialogTitle'
import { ExtraSmallButton } from '../../../custom'
import ClearIcon from '../../../../assets/icons/ClearIcon'
import { useNonModalDialog } from '../../../common/useNonModalDialog'
import { useFullscreenContainer } from '../../../../hooks/useFullscreenContainer'
import { WidgetSettingsMenuProvider } from '../../widgetSettingsMenuContext'
import { OpenInterestChartSettings } from '../../../chartV2/chart.typings'
import { Security } from '../../../../proto/generated/security'
import OpenInterestSettingsPanel from './OpenInterestSettingsPanel'

type Props = {
    open: boolean
    onClose: () => void
    settings: OpenInterestChartSettings
    onSettingsPatch: (patch: Partial<OpenInterestChartSettings>) => void
    security?: Security
}

const OpenInterestSettingsDialog = ({
    open,
    onClose,
    settings,
    onSettingsPatch,
    security,
}: Props) => {
    const fullscreenContainer = useFullscreenContainer()
    const { dialogProps, paperRef } = useNonModalDialog(open, onClose)

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            container={fullscreenContainer ?? undefined}
            {...dialogProps}
            PaperProps={{
                ref: paperRef,
                sx: { minHeight: '40%', maxHeight: 'max-content', pointerEvents: 'auto' },
            }}
        >
            <DraggableDialogTitle>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Typography variant="h6">Settings</Typography>
                    <ExtraSmallButton onClick={onClose} aria-label="close" color="inherit">
                        <ClearIcon />
                    </ExtraSmallButton>
                </Stack>
            </DraggableDialogTitle>
            <DialogContent sx={{ padding: 0, display: 'flex', flexDirection: 'column' }}>
                <WidgetSettingsMenuProvider>
                    <OpenInterestSettingsPanel
                        settings={settings}
                        onSettingsPatch={onSettingsPatch}
                        security={security}
                    />
                </WidgetSettingsMenuProvider>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button variant="contained" onClick={onClose}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default OpenInterestSettingsDialog
